export const S3_DOMAIN2 = 'https://dw7qkw9o88bie.cloudfront.net'

export const deviceIdKey = 'deviceId'
